import i18n from 'i18next';

// TRANSLATIONS
export const transUTL = (key) => i18n.t(key);
export const langUTL = (language) => i18n.changeLanguage(language);
